import React from 'react';
import ContainerWrapper from './style';

const Container = ({ children, WidthSize, Margin, Background }) => (
  <ContainerWrapper WidthSize={WidthSize} Margin={Margin}>{children}</ContainerWrapper>
);

export default Container;
